<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div class="ld-panel-title">
		<router-link to="/account/index" class="back-btn"><span></span>修改密码</router-link>
	</div>
	<div class="ld-panel-main">
		<el-alert title="注意账户安全，请尽量避免采用手机号、电话号码、生日、学号、身份证等个人信息设置密码" type="warning" show-icon :closable="false" style="margin-bottom: 24px;" />
		<div v-if="!checkToken"><code-verification :secver-type="secverType" @tokenChange="codeCheck" /></div>
		<el-form v-else :rules="rules" ref="ruleFormRef" inline-message :model="groupForm" :label-width="formLabelWidth">
			<el-form-item label="会员ID">
				<el-input v-model="userid" disabled />
			</el-form-item>
			<el-form-item label="当前登录密码" prop="oldpwd">
				<el-input v-model="groupForm.oldpwd" type="password" show-password autocomplete="off" />
			</el-form-item>
			<el-form-item label="新的登录密码" prop="newpwd">
				<el-input v-model="groupForm.newpwd" type="password" show-password autocomplete="off" />
			</el-form-item>
			<ul class="form-tip" style="margin-left: 160px;">
				<li>密码长度6~16字符，至少包含字母、数字两种形式，不能包含空格与特殊字符</li>
				<li>密码强度</li>
			</ul>
			<el-form-item label="确认新密码" prop="renewpwd">
				<el-input v-model="groupForm.renewpwd" type="password" show-password autocomplete="off" />
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submitForm(ruleFormRef)">提交</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import Cookies from 'js-cookie';
	import { changePwd } from '@/api/account';
	import sideNav from '../../components/sideNav.vue';
	import codeVerification from '../../components/codeVerification.vue';
	import { ElMessage, ElMessageBox } from 'element-plus';
	
	const router = useRouter();
	const pageTitle = 'account';
	const secverType = 'changepwd';
	const userid = Cookies.get('LDUSERNAME');
	const formLabelWidth = ref('160px');
	const checkToken = ref(false);
	const authWay = ref('');
	const ruleFormRef = ref(null);
	const groupForm = ref({newpwd:'',oldpwd:'',renewpwd:''});
	const passValidate = (rule, value, callback) => {
		var count = 0;
		if(/\d/.test(value)) count++
		if(/[a-z]/.test(value)) count++
		if(/[A-Z]/.test(value)) count++
		if(/[_。%#@]/.test(value)) count++
		if(count < 3) {
			callback(new Error('密码必须包含大写字母、小写字母、数字及特殊符号中至少三项'))
		} else {
			callback()
		}
	};
	const passValidate2 = (rule, value, callback) => {
		if (value === '') {
			callback(new Error('请再次填写新密码'))
		} else if(value !== groupForm.value.newpwd){
			callback(new Error('两次填写的密码不一致'))
		} else {
			callback()
		}
	};
	const rules = reactive({
		oldpwd: [
			{ required: true, message: '请填写当前登录密码', trigger: 'blur' }
		],
		newpwd: [
			{ required: true, message: '密码长度8~16字符,包含大写字母、小写字母、数字及特殊符号中至少三项', trigger: 'blur' },
			{ min: 8,max:16, message: '密码长度8~16字符,包含大写字母、小写字母、数字及特殊符号中至少三项', trigger: 'blur' },
			{ validator: passValidate, trigger: 'blur' }
		],
		renewpwd: [
			{ required: true, message: '请再次填写密码', trigger: 'blur' },
			{ validator: passValidate2, trigger: 'blur' }
		]
	});
	
	
	const codeCheck = (token,way) =>{
		checkToken.value = token;
		authWay.value = way;
	};
	const submitForm = () => {
		if (!ruleFormRef.value) return;
		ruleFormRef.value.validate((valid) => {
			if (valid) {
				const param = groupForm.value;
				param['way'] = authWay.value;
				changePwd(param).then((res) => {
					if(res.code === 200){
						ElMessage({
							offset:70,
							message: res.msg,
							type: 'success'
						})
						router.back();
					}
				})
			} else {
			  return false;
			}
		});
	};

	
</script>

<style>
</style>